__turbopack_context__.v({
  "icon-root": "icon-module-scss-module__g0MQgW__icon-root",
});
